export default __webpack_public_path__ + "static/media/undraw_doctors_stock.5280916b.svg";